module.exports = __webpack_public_path__ + "img/mallStop.da0a22bd.png";